import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { type FrontendConfiguration, getFrontendConfiguration } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useConfiguration(): UseQueryResult<FrontendConfiguration, AxiosError> {
    const queryKey = useMemo(() => queryKeys.configuration(), []);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getFrontendConfiguration({ signal }).then((result) => result.data),
    });
}
